import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { SelectOption } from '../../shared/models/dropdowm.model';
import { CreateOffer, OfferStatus, UpdateOffer } from '../models/offer.model';

@Injectable({
  providedIn: 'root',
})
export class OfferService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    sku?: string,
    status?: OfferStatus | null
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (sku) params += `&productId=${sku}`;
    if (status) params += `&status=${status}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/offers?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(this.apiBaseUrl + '/api/v1/offers/' + id);
  }

  create(data: CreateOffer) {
    return this.http.post<ApiResult>(this.apiBaseUrl + '/api/v1/offers', data);
  }

  updateStatus(id: string, data: UpdateOffer) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/offers/${id}/status`,
      data
    );
  }

  getOfferStatusOptions(): SelectOption[] {
    return [
      { label: 'Rascunho', value: OfferStatus.Draft },
      { label: 'Ativo', value: OfferStatus.Active },
      { label: 'Inativo', value: OfferStatus.Inactive },
    ];
  }
}
